// extracted by mini-css-extract-plugin
module.exports = {"selectText":"SrmDetails_selectText__3JGL-"};